import OrganisationRolesScene from '../scenes/OrganisationRolesScene';

const routes = [
  {
    path: '/organisation-roles',
    component: OrganisationRolesScene,
    exact: false,
    menuName: 'organisationRoles_plural',
    hasSomeRights: ['ORGANISATIONROLES.MANAGE.ALL', 'ORGANISATIONROLES.READ.ALL'],
  },
];

export default routes;
